import getCollection from "../../helpers/getCollection";
import runBatch from "../../helpers/runBatch";
import createDocumentData from "../../utils/createDocumentData";

import organizationTypes from "./constants/organizationTypes";
import { Organization } from "./types/Organization";

export default async function createOrganization(firebase, { type, name, languageDefault, user }) {
	const db = firebase.firestore();

	const organizations = await getCollection(
		db.collection("organizations").where("type", "==", type).where("name", "==", name),
	);

	if (organizations.length > 0) {
		throw new Error("name unavailable");
	}

	const addProducerId = user?.permissions?.role === "admin" && user?.adminProducerIds;

	const isPublisher = type === organizationTypes.PUBLISHER;

	const organization = Organization.parse(
		createDocumentData(firebase, "organizations", {
			name,
			type,
			languageDefault,
			// languageDefault must be one of languageOptions, or the language settings page resets it
			languageOptions: languageDefault ? [languageDefault] : [],
			// non-publishers get no automatic distribution types; publishers fall through to the schema default
			automaticDistributionTypes: isPublisher ? undefined : [],
			featureFlags: isPublisher ? ["flattening"] : undefined,
		}),
	);

	await runBatch(db, (batch) => {
		batch.set(organization.ref, organization);

		if (addProducerId) {
			batch.update(user.ref, {
				adminProducerIds: firebase.firestore.FieldValue.arrayUnion(organization.ref.id),
			});
		}
	});

	return organization.ref;
}
